import React from 'react';
import styled, { css } from 'styled-components';

import useBreakpoint from '@hooks/breakpoint';
import TransactionCardSkeleton from './TransactionCard/TransactionCard.skeleton';
import TransactionTableSkeleton from './TransactionTable/TransactionTable.skeleton';

const StyledTransactionsSkeleton = styled.div(
  ({ theme }) => css`
    margin-top: 16px;
    ${theme.breakpoint('md')} {
      margin-top: 24px;
    }
  `
);

const TransactionsSkeleton = ({ falabella }) => {
  const { mobile } = useBreakpoint();
  const test = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  return (
    <>
      <StyledTransactionsSkeleton>
        {mobile ? (
          <div data-testid="transaction-cards-skeleton">
            {test.map((i, index) => (
              <TransactionCardSkeleton key={index} />
            ))}
          </div>
        ) : (
          <TransactionTableSkeleton data={test} falabella={falabella} />
        )}
      </StyledTransactionsSkeleton>
    </>
  );
};

export default TransactionsSkeleton;
